<template>
  <div class="main-container billing-table-height">
    <div style="width: 100%">
      <el-input
        style="max-width: 200px"
        placeholder="Type Customers ID"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        :lineNumbers="true"
        :columns="fields"
        :rows="getUsers"
        :isLoading="isLoadingVGT"
        :search-options="{
          enabled: true,
          searchFn: searchTable,
          externalQuery: searchTerm
        }"
        :pagination-options="{ enabled: true }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'firstName'">
            {{ props.row.user ? props.row.user.firstName : "----" }}
          </span>
          <span v-if="props.column.field == 'lastName'">
            {{ props.row.user ? props.row.user.lastName : "----" }}
          </span>
          <span v-if="props.column.field == 'deviceId'">
            {{ props.row.installation ? props.row.installation.CID : "----" }}
          </span>

          <span v-if="props.column.field == 'totalPrice'">
            {{
              (props.row.totalPrice ? props.row.totalPrice : "----").replace(
                /\B(?=(\d{3})+(?!\d))/g,
                ","
              )
            }}
          </span>

          <span v-if="props.column.field == 'monthlyCharge'">
            {{
              (props.row.monthlyCharge
                ? props.row.monthlyCharge
                : "----"
              ).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }}
          </span>

          <span v-if="props.column.field == 'amountPaid'">
            {{
              (props.row.totalAmountPaid
                ? props.row.totalAmountPaid
                : "----"
              ).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }}
          </span>

          <span v-if="props.column.field == 'numberOfTimesPaymentIsMade'">
            {{
              props.row.numberOfTimesPaymentIsMade
                ? props.row.numberOfTimesPaymentIsMade
                : "----"
            }}
          </span>

          <span v-if="props.column.field == 'remainingPayment'">{{
            (props.row.totalPrice - props.row.totalAmountPaid).toLocaleString(
              "en-US"
            )
          }}</span>
          <span v-if="props.column.field == 'remainingDuration'">
            {{
              props.row.duration - props.row.numberOfTimesPaymentIsMade
            }}</span
          >
          <span v-if="props.column.field == 'monthlyRecurringChargeDate'">
            {{
              formatDate(props.row.monthlyRecurringChargeDate)
                ? formatDate(props.row.monthlyRecurringChargeDate)
                : "----"
            }}
          </span>
          <span v-if="props.column.field == 'actions'">
            <router-link
              :to="{
                name: 'BillingUpdate',
                params: {
                  id: props.row.id,
                  installationCID: props.row.installation
                    ? props.row.installation.CID
                    : 0,
                  monthlyCharge: props.row.monthlyCharge,
                  numbOfpayment: props.row.numberOfTimesPaymentIsMade,
                  chargeDate: formatDate(props.row.monthlyRecurringChargeDate),
                  pDuration: props.row.duration ? props.row.duration : 0,
                  amounts: props.row.totalPrice
                }
              }"
            >
              <i class="fa fa-edit"></i> &nbsp;
            </router-link>

            <button
              class="red-border"
              @click="
                deleteModal(
                  props.row.installation ? props.row.installation.CID : 0,
                  props.row.id
                )
              "
            >
              <i class="fa fa-trash"></i>
            </button>
          </span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>

      <modal name="my-first-modal">
        <div class="form" style="width: 80%;">
          <form name="myForm" method="" @submit="deletionDetails">
            <h4>
              Are you sure you want to delete device
              {{ idSelected }}?
            </h4>
            <input
              type="text"
              name="fname"
              class="form-control form-control-lg"
              id="modalText"
              :required="true"
              v-model="deleteReason"
              placeholder="State your reason for deleting the user"
            />

            <div class="row">
              <button
                type="submit"
                class="button-delete"
                @click.prevent="deletionDetails(deleteDevice)"
              >
                Delete
              </button>
              <button type="submit" class="button-cancel" @click="cancel">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import {
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
} from "element-ui";
import moment from "moment";
moment.updateLocale("en", {
  monthsShort: "Jan_Feb_Mar_Apr_May_June_July_Aug_Sept_Oct_Nov_Dec".split("_")
});

const items = [];
export default {
  name: "BillingListing",
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      searchTerm: "",
      isLoadingVGT: true,
      editOffCanvas: false,
      isLoading: false,
      deleteReason: "",
      idSelected: "",
      disableButton: "",
      userID: "",
      regParams: {},
      selectOption: {
        enabled: true
      },
      items: items,

      fields: [
        {
          field: "firstName",
          label: "First Name",
          sortable: "true"
        },
        {
          field: "lastName",
          label: "Last Name",
          sortable: "true"
        },
        {
          field: "deviceId",
          label: "Device ID",
          sortable: "true"
        },
        {
          field: "totalPrice",
          label: "Total Price (NGN)",
          sortable: "true"
        },
        {
          field: "monthlyCharge",
          label: "Monthly Charge (NGN)",
          sortable: "true"
        },
        {
          field: "amountPaid",
          label: "Amount Paid (NGN)",
          sortable: "true"
        },
        {
          field: "remainingPayment",
          label: "Amount Remaining (NGN)"
        },
        {
          field: "numberOfTimesPaymentIsMade",
          label: "Number of payment made",
          sortable: "true"
        },
        {
          field: "remainingDuration",
          label: "no. of payment remaining"
        },
        {
          field: "monthlyRecurringChargeDate",
          label: "Recurring Date",
          sortable: "true"
        },
        {
          field: "actions",
          label: "Actions"
        }
      ],
      getUsers: "",
      currentPage: 1,
      details: ["UserDetails", "allowUser"],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      showModal: true,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },
  computed: {
    ...mapGetters(["getUsers"]),
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          };
        });
    }
  },
  methods: {
    show() {
      this.$modal.show("my-first-modal");
    },
    hide() {
      this.$modal.hide("my-first-modal");
    },
    toggleIsLoading() {
      this.isLoading = !this.isLoading;
    },
    deleteModal(data1, data2) {
      this.idSelected = data1;
      this.userID = data2;
      this.show();
    },
    cancel() {
      this.idSelected = "";
      this.userID = "";
      this.hide();
    },
    deleteDevice(userIds) {
      console.log(userIds);
      const HTTP = this.$httpUtils.instance;
      const url = `/billings/${userIds}`;
      HTTP.delete(url, this.userID)
        .then(res => {
          this.showSuccessMsg({ message: "Device Deleted!" });
          this.init();
          this.hide();
          console.log("DELETED");
        })
        .catch(error => {
          this.showErrorMsg({ message: error.response.data.error.message });
        });
    },
    validateInput() {
      this.deleteReason = document.forms["myForm"]["fname"].value;
      if (this.deleteReason == "") {
        alert("Name must be filled out");
        return false;
      }
      return true;
      // if (
      //   this.deleteReason.value === "null" ||
      //   this.deleteReason.value === "NaN"
      // ) {
      //   console.log(`field is empty`);
      // } else {
      //   console.log("field is filled");
      // }
    },
    deletionDetails(callback) {
     if (! this.validateInput()) return
      
      const httpUtils = this.$httpUtils;
      // let url = `/billings/getAllUserSchedules?filter={"where":{"id":${this.userID}}}`;
      // httpUtils.instance
      //   .get(url)
      //  log({ okay });
        // }) .then(response => {
          // console.log(url, this.userID);
          // let pass = response.data.data[0];
          // let okay = pass.find(obj => (obj.id = this.userID));
          // console.
        // .catch(error => {
        //   this.showErrorMsg({ message: "Error occured at our end!" });
        // });
      console.log("Hello world");
      console.log(this.deleteReason);

      // what to delete
      // return
      let userIds = this.userID;
      callback(userIds);

      const HTTP = this.$httpUtils.instance;
      HTTP.post("/CustomerDeletedBillings",{billingId:this.userID, deleteReason:this.deleteReason})
        .then(res => {
          console.log("customer deleted");
        })
        .catch(error => {
          this.showErrorMsg({
            message: error.response.data.error.message.message
          });
          this.showErrorMsg({ message: showInfoMsg });
        });
    },

    searchTable(row, col, cellValue, searchTerm) {
      return (
        Object.values(row)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    toggleEditCanvas(data) {
      this.regParams = data;
      this.editOffCanvas = !this.editOffCanvas;
    },
    formatDate(date) {
      return moment(date).format("DD MMMM, YYYY");
    },
    init() {
      const httpUtils = this.$httpUtils;
      let url = `/billings/getAllUserSchedules`;

      httpUtils.instance
        .get(url)
        .then(response => {
          this.getUsers = response.data.data[0];
          this.isLoadingVGT = false;
        })
        .catch(error => {
          this.showErrorMsg({ message: "Error occured at our end!" });
        });
    }
  },
  async mounted() {
    this.init();
  }
};
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

.form {
  margin: 100px auto;
}

h4 {
  font-weight: 600;
  color: #6a707e;
  border: none;
  text-align: center;
}

.row {
  margin: 20px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.button-delete {
  padding: 5px;
  color: white;
  border-color: red;
  background: red;
  width: 49%;
  margin-left: -7px;
}

.red-border {
  border: 2px solid red;
  width: 30px;
}

.button-cancel {
  padding: 5px;
  color: #269af1;
  background: white;
  border-color: #269af1;
  width: 49%;
  margin-right: -7px;
}

table th,
table th span {
  font-size: 0.7em;
}
.billing-table-height {
  height: calc(100vh - 250px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/adminBilling/BillingListing.vue